import { render, staticRenderFns } from "./Slice--Media.vue?vue&type=template&id=a1533918&lang=pug&"
import script from "./Slice--Media.vue?vue&type=script&lang=js&"
export * from "./Slice--Media.vue?vue&type=script&lang=js&"
import style0 from "./Slice--Media.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports